export default "__VITE_ASSET__afe80e7e__"